import { render, staticRenderFns } from "./WaiterFamilyEdit.vue?vue&type=template&id=46541fae&scoped=true&lang=pug"
import script from "./WaiterFamilyEdit.vue?vue&type=script&lang=ts"
export * from "./WaiterFamilyEdit.vue?vue&type=script&lang=ts"
import style0 from "./WaiterFamilyEdit.vue?vue&type=style&index=0&id=46541fae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46541fae",
  null
  
)

export default component.exports